import { styled } from "styled-components";
import CustomModal from "./mocks/Modal";
import BottomSheet from "./mocks/BottomSheetPreview";

const Container = styled.div`
  height: 836px;
  width: 393px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

export default function ModalPreviews() {
  return (
    <Container>
      <CustomModal />
      <BottomSheet />
    </Container>
  );
}
